import { render, staticRenderFns } from "./TendenciaHistorica.vue?vue&type=template&id=6bc43e2d&scoped=true&"
import script from "./TendenciaHistorica.vue?vue&type=script&lang=js&"
export * from "./TendenciaHistorica.vue?vue&type=script&lang=js&"
import style0 from "./TendenciaHistorica.vue?vue&type=style&index=0&id=6bc43e2d&scoped=true&lang=css&"
import style1 from "./TendenciaHistorica.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc43e2d",
  null
  
)

export default component.exports